import * as React from 'react';
import { Product } from '~/Api/Product';
import { CaLabeling } from '~/Api/User/ProductGroup/CaLabeling';

export const ProductProvider: React.FunctionComponent<
	React.PropsWithChildren<{
		caLabeling: CaLabeling | null;
		id: string;
		children(product: Product | null): React.ReactNode;
	}>
> = ({ caLabeling, id, children }) => {
	const product = React.useMemo(
		() => caLabeling?.products.find((candidate) => candidate.product.id === id)?.product ?? null,
		[caLabeling, id]
	);
	return <>{children(product)}</>;
};

ProductProvider.displayName = 'CaLabeling.ProductProvider';
